import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Stack,
  Fade,
} from '@mui/material'
import ContentItem from './ContentItem'
import ContentUtils from '../utils/content'
import localization from '../utils/localization'

function ModalCreateMenu(props) {
  const menuItems = [
    {
      type: ContentUtils.getPasswordType(),
      label: localization.strings.createPassword,
    },
    {
      type: ContentUtils.getTextType(),
      label: localization.strings.createText,
    },
    {
      type: ContentUtils.getTotpType(),
      label: localization.strings.createTotp,
    },
    {
      type: ContentUtils.getBlockChainType(),
      label: localization.strings.createBlockchain,
    },
  ]

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          backgroundColor: '#F8FAFC',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {localization.strings.addNewItem}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ color: '#64748B', textAlign: 'center', mb: 4 }}>
              {localization.strings.createMenuDesc}
            </Typography>

            <Stack spacing={2}>
              {menuItems.map((item, index) => (
                <ContentItem
                  key={index}
                  contentType={item.type}
                  text={item.label}
                  onClick={() => {
                    props.onClick(item.type)
                  }}
                />
              ))}
            </Stack>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalCreateMenu
